<template>
  <div
    class="form-group"
    :class="[inputGroupClass, {
        'has-prefix': !!$slots.prefix,
        'has-suffix': !!$slots.suffix,
        'is-elastic': enableElastic
    }]"
  >
    <label class="form-label" :class="{ 'has-error ': error }" v-if='label'>{{ label  }}</label>
    <div class="form-group__panel">
      <input
        class="form-control"
        :class="[inputClasses, { 'has-error ': error }]"
        :style="inputStyles"
        type="search"
        v-on="inputListeners"
        v-bind="$attrs"
      />
    </div>
    <transition name="slide">
      <span v-show="error" class="form-feedback is-danger">{{ error }}</span>
    </transition>
  </div>
</template>

<script>
/* eslint-disable arrow-parens */
import themeSetupMixin from '@/mixins/theme';
import inputMixin from '../input.mixin';

export default {
  mixins: [themeSetupMixin, inputMixin],
  props: {
    error: String,
    label: String,
    /**
     * ClassNames for input group
    */
    inputGroupClass: {
      type: String,
      default: '',
    },
    /**
     * ClassNames for input
    */
    inputClasses: {
      type: String,
      default: '',
    },
    /**
     * Inline Styles for input
    */
    inputStyles: {
      type: String,
      default: '',
    },
    /**
     * If `true`, it allows the search input to expand when the search icon is clicked
    */
    enableElastic: Boolean,
  },
  data() {
    return {
      isElastic: false,
    };
  },
  methods: {
    toggleInput() {
      this.isElastic = !this.isElastic;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_variables.scss";

input[type=search] {
  -webkit-appearance: textfield;
  -webkit-box-sizing: content-box;
  font-family: inherit;
  font-size: 100%;
  background: url(../../../../assets/images/search.png) no-repeat 99% 9px;
  padding:10px;
  -webkit-transition: all .5s;
  -moz-transition: all .5s;
  transition: all .5s;
}
input::-webkit-search-decoration,
input::-webkit-search-cancel-button {
  display: none;
}
.is-elastic {
  min-width: 0px;
  .form-control {
    width: 0;
    border:none;
    color: transparent;
    cursor: pointer;
    padding-left:9px;
  }
}
input[type=search]:focus {
  width: 100%;
  background-color: var(--brand-white);
  border:1px solid  var(--brand-light);
  width: 100%;
  padding-right: 32px;
  color: var(--text-10);
  background-color: var(--brand-white);
  cursor: auto;
}
input::-webkit-input-placeholder {
  color: var(--text-30);
}
input[type=search]:hover {
  background-color: var(--brand-white);
}
input:-moz-placeholder {
  color: transparent;
}
input::-webkit-input-placeholder {
  color: transparent;
}
</style>
